import { useBundle } from '@amzn/react-arb-tools';
import { useCallback } from 'react';
import messages from 'src/i18n/translations/star-grid.json';

const fallback = messages.en['pages.starGrid'];
export type StarGridTextKey = keyof typeof fallback;
export type StarGridText = (key: StarGridTextKey) => string;

export function useStarGridText(): StarGridText {
  const [bundle] = useBundle('pages.starGrid');
  return useCallback(
    (key: StarGridTextKey): string => {
      try {
        return bundle?.getMessage(key) ?? fallback[key];
      } catch {
        return fallback[key];
      }
    },
    [bundle]
  );
}
